export default "__VITE_ASSET__B0h90W79__"